import { Condition, ConditionComparison, ValueSource } from '../../models/Condition';
import { OutputViewModel } from '../../models/viewModels/OutputViewModel';
import { AGENT_FORWARD_TO_AGENT_STATE_STATUS } from './Actions';
import { CreateAgentStatus } from './Enums';
export const variableCondition = 'input.content@content.value.name';
export const variableConditionByType = 'input.content@content.value.type';
export const variableValueHandoff = 'application/vnd.iris.aiplatform.handoff+json';
export const variableConditionHandoff = 'input.content@content.type';
export function findConditionOutputs(typeForward) {
    return (co) => co.$isAgentOutput &&
        !co.$isAgentDefaultOutput &&
        !co.$isAgentCustomOutput &&
        co.conditions.filter(cond => cond.variable === variableConditionHandoff &&
            cond.source === ValueSource.Context &&
            cond.comparison === ConditionComparison.Equals)[0]?.values?.includes(variableValueHandoff) &&
        co.conditions.filter(cond => cond.variable === variableConditionByType &&
            cond.source === ValueSource.Context &&
            cond.comparison === ConditionComparison.Equals)[0]?.values?.includes(typeForward);
}
export function createOutputCondition(typeForward) {
    const output = OutputViewModel.create();
    output.$isAgentOutput = true;
    output.$isAgentCustomOutput = false;
    output.$isAgentDefaultOutput = false;
    output.conditions = [
        new Condition({
            source: ValueSource.Context,
            variable: variableConditionHandoff,
            comparison: ConditionComparison.Equals,
            values: [variableValueHandoff],
        }),
        new Condition({
            source: ValueSource.Context,
            variable: variableConditionByType,
            comparison: ConditionComparison.Equals,
            values: [typeForward],
        }),
    ];
    return output;
}
export const conditionInputAiAgents = [
    new OutputViewModel({
        $isAgentOutput: true,
        $isAgentCustomOutput: false,
        $isAgentDefaultOutput: true,
        conditions: [
            new Condition({
                source: ValueSource.Context,
                variable: AGENT_FORWARD_TO_AGENT_STATE_STATUS,
                comparison: ConditionComparison.Equals,
                values: [CreateAgentStatus.Error],
            }),
        ],
        stateId: 'fallback',
        $invalid: false,
    }),
];
